import API_CONFIG from '@/services/api/config.js'

function setDataExpiry(payload = { storeDays: 0, receiveDays: 0 }) {
	return async (dispatch) => {

		sessionStorage.setItem('dataExpiry', JSON.stringify(payload))
		dispatch({
			type: 'dataExpiry/set',
			payload: payload
		})
	}
}

function retrieveDataExpiry() {
	return async (dispatch) => {
		const [error, data] = await API_CONFIG.checkAttachment()

		if (error) {
			console.error('Unable to fetch Attachment API')
			dispatch({
				type: 'dataExpiry/error',
				payload: 'Unable to fetch Attachment API'
			})
			return
		}

		let payload = {
			storeDays: Number(data.uploaded_attachment_exp) || 0,
			receiveDays: Number(data.received_attachment_exp) || 0
		}

		sessionStorage.setItem('dataExpiry', JSON.stringify(payload))
		dispatch({
			type: 'dataExpiry/set',
			payload: payload
		})
	}
}

export {
	setDataExpiry,
	retrieveDataExpiry
};

